import VonalkodTesztlapDto from 'app/admin/vonalkodtesztlap/dto/VonalkodTesztlapDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class VonalkodTesztlapTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'tesztlapTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, VonalkodTesztlapDto)))
				.catch(reject);
		});
	}
}

export default new VonalkodTesztlapTableService();
